module.exports = __webpack_public_path__ + "img/banner6.e940785f.e940785f.jpg";